import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { ContextService } from '../context.service';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { FloSnackbarComponent } from '../snackbar/floSnackbar.component';
import { EventHandlerService } from '../entry/EventHandlerService';
import { TrialExpiredService } from '../shared/services/trial-expired.service';
import { ExportService, ExportSettings, ExportSettingsService } from '@savvy/export';

import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { ContextIdDto } from '@savvy/view-definition';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-export-customers',
  templateUrl: './exportCustomers.component.html',
})
export class ExportCustomersComponent implements OnInit, OnDestroy {

  contextIdDto: ContextIdDto;
  subscriptions: Subscription[] = [];
  exporting = false;
  exportType = 'allCustomers';
  exportSettings: ExportSettings;


  constructor(
    private router: Router,
    public http: HttpClient,
    private injector: Injector,
    private eventHandler: EventHandlerService,
    private notify: FloSnackbarComponent,
    private contextService: ContextService,
    public trialExpiredService: TrialExpiredService,
    private route: ActivatedRoute,
    private exportSettingsService: ExportSettingsService,
    private api: ExportService) {
  }

  ngOnInit() {
    console.log('inside on init students.component.ts');
    this.subscriptions.push(this.contextService.contextIdDto$.subscribe(data => {
      if (data) {
        this.contextIdDto = data;
        this.load();
      }
    }));
  }

  load() {
    this.exportSettingsService.loadSettings(this.contextIdDto.contextId, 'ENV_ID').subscribe(response => {
      this.exportSettings = response;
    })
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  exportData() {
    console.log('exporting data', this.exportType);

    this.exporting = true;
    if (this.exportType === 'allCustomers') {
      return this.api.exportCustomers(this.contextIdDto.contextId, this.contextIdDto.contextIdType).subscribe(
        response => {
          console.log('got export');
          this.exporting = false;
          const blob = new Blob([response.lines], { type: 'text/csv;charset=utf-8' });
          saveAs(blob, 'customers.csv');
          // this.saveFile(data, 'customers.csv');
          // saveAs(data.file, 'customers.csv');
        }, error => {
          this.exporting = false;
        });
    } else if (this.exportType === 'marketingEmail') {
      return this.api.exportCustomersForMarketing(this.contextIdDto.contextId, this.contextIdDto.contextIdType).subscribe(
        response => {
          console.log('got export');
          this.exporting = false;
          const blob = new Blob([response.lines], { type: 'text/csv;charset=utf-8' });
          saveAs(blob, 'customers.csv');
          // this.saveFile(data, 'customers.csv');
          // saveAs(data.file, 'customers.csv');
        }, error => {
          this.exporting = false;
        });
    } else if (this.exportType === 'emailList') {
      return this.api.exportCustomersForEmail(this.contextIdDto.contextId, this.contextIdDto.contextIdType).subscribe(
        response => {
          console.log('got export');
          this.exporting = false;
          const blob = new Blob([response.lines], { type: 'text/csv;charset=utf-8' });
          saveAs(blob, 'customers.csv');
          // this.saveFile(data, 'customers.csv');
          // saveAs(data.file, 'customers.csv');
        }, error => {
          this.exporting = false;
        });
    } else {
      console.log('unknown export type ', this.exportType);
    }
  }

  saveFile(data: any, filename?: string) {
    const blob = new Blob([data], { type: 'text/csv; charset=utf-8' });
    saveAs(blob, filename);
  }
}
